import {createAction} from "redux-act";
import {IFanVoteSavedModal, IShowFieldDetailsModal, ITeam, Nullable} from "modules/types";

export const toggleErrorModal = createAction<Nullable<string>>();
export const toggleSuccessModal = createAction<Nullable<ITeam>>();

export const openSSOAdditionalFieldsModal = createAction();
export const closeSSOAdditionalFieldsModal = createAction();

export const openDontLoseTeamModal = createAction();
export const closeDontLoseTeamModal = createAction();

export const openPlayerDetailsModal = createAction<IShowFieldDetailsModal>();
export const closePlayerDetailsModal = createAction();

export const openFanVoteSavedModal = createAction<IFanVoteSavedModal>();
export const closeFanVoteSavedModal = createAction();

export const openConfirmPicksModal = createAction();
export const closeConfirmPicksModal = createAction();
